/**
 * LibraryEnv — the library is auto-publish (writes go directly to live).
 * Tracks GitHub-managed state to disable editing when active.
 */

import React, { createContext, useContext, useEffect, useState } from "react";
import * as api from "./api.js";

const GitHubManagedContext = createContext(false);

export function LibraryEnvProvider({ children }) {
  const [managed, setManaged] = useState(false);

  useEffect(() => {
    api.getGitHubConfig()
      .then((res) => setManaged(!!res.data?.github_library_managed))
      .catch(() => {});
  }, []);

  return (
    <GitHubManagedContext.Provider value={managed}>
      {children}
    </GitHubManagedContext.Provider>
  );
}

export function useLibraryEnv() {
  const managed = useContext(GitHubManagedContext);
  return {
    env: "live",
    isDraft: false,
    isLive: managed, // true when GitHub-managed → disables editors
    setEnv: () => {},
  };
}

export function useEnvPrefix() {
  return "/library";
}
